export const FieldVariableEntity = {
  Profile: 'profile',
}

export const FieldVariableUsage = {
  Automation: 'automation',
  Chat: 'chat',
  DocumentStapling: 'document_stapling',
  Email: 'email',
  ExternalTemplates: 'external_templates',
  ManagerEmail: 'manager_email',
  MassEmailing: 'mass_emailing',
  PostComment: 'post_comment',
  ProviderEmail: 'provider_email',
  RequestComment: 'request_comment',
  RequestEmail: 'requestthread_email',
  RequestFeedback: 'request_feedback',
}

export const FIELD_VARIABLE_USAGE_LABEL_KEY = {
  [FieldVariableUsage.Automation]: 'FieldVariable.UsageAutomationKey',
  [FieldVariableUsage.Chat]: 'FieldVariable.UsageChatKey',
  [FieldVariableUsage.DocumentStapling]:
    'FieldVariable.UsageDocumentStaplingKey',
  [FieldVariableUsage.Email]: 'FieldVariable.UsageEmailKey',
  [FieldVariableUsage.ExternalTemplates]:
    'FieldVariable.UsageExternalTemplatesKey',
  [FieldVariableUsage.ManagerEmail]: 'FieldVariable.UsageManagerEmailKey',
  [FieldVariableUsage.MassEmailing]: 'FieldVariable.UsageMassEmailingKey',
  [FieldVariableUsage.PostComment]: 'FieldVariable.UsagePostCommentKey',
  [FieldVariableUsage.ProviderEmail]: 'FieldVariable.UsageProviderEmailKey',
  [FieldVariableUsage.RequestComment]: 'FieldVariable.UsageRequestCommentKey',
  [FieldVariableUsage.RequestEmail]: 'FieldVariable.UsageRequestEmailKey',
  [FieldVariableUsage.RequestFeedback]: 'FieldVariable.UsageRequestFeedbackKey',
}

export const FIELD_VARIABLE_USAGE_SEPARATOR = ', '

export const FIELD_VARIABLE_INFO_HOVER_DELAY = {
  close: 100,
  open: 200,
}

export const QA_NAME_FIELD_VARIABLE_COPY_BUTTON = 'fieldVariableCopyButton'

export const QA_NAME_FIELD_VARIABLE_INFO = 'fieldVariableInfo'
